import React from 'react';
import { mockGameFeatures } from '../mock';
import { Sprout, PawPrint, Cpu } from 'lucide-react';

const iconMap = {
  Sprout: Sprout,
  PawPrint: PawPrint,
  Cpu: Cpu
};

const Features = () => {
  return (
    <section id="features" className="bg-black py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            Powerful Gaming Features
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] max-w-2xl mx-auto">
            Experience next-generation farming with blockchain technology
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {mockGameFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group border border-[rgba(255,255,255,0.25)] bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(0,255,209,0.05)] transition-all duration-400 overflow-hidden"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-400"
                  />
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center mb-4">
                    {IconComponent && <IconComponent className="w-6 h-6 text-black" />}
                  </div>
                  <h3 className="text-[24px] font-semibold leading-[1.3] text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-[18px] font-normal leading-[1.5] text-[rgba(255,255,255,0.85)]">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
